import { AuthService } from "src/app/Auth/auth.service";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"]
})
export class NavbarComponent implements OnInit, OnDestroy {
  constructor(private as: AuthService, private router: Router) {}

  isAuth: boolean = false;
  sub: Subscription;
  isAdmin: boolean = false;

  ngOnInit() {
    this.sub = this.as.User.subscribe(user => {
      if (user && user.email === "test@test.com") {
        this.isAuth = true;
      } else if (user && user.email === "admin@admin.com") {
        this.isAuth = true;
        this.isAdmin = true;
      } else {
        this.isAuth = false;
      }
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  logOut() {
    this.isAuth = false;
    this.isAdmin = false;
    this.as.logOut();
    this.router.navigate(["/"]);
  }
}
